// core version + navigation, pagination modules:
import { loadTranslations } from '../utils';
import Swiper from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { A11y, Pagination, Navigation } from 'swiper/modules';


export default async function () {
  const pageLang = document.documentElement.lang || 'fr';
  const t = await loadTranslations(pageLang);

  document.querySelectorAll('.swiper--partners').forEach((el) => {
    const swiperPartners = new Swiper(el, {
      modules: [A11y, Pagination, Navigation],
      direction: 'horizontal',
      loop: true,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      },
      a11y: {
        prevSlideMessage: t.prevSlideMessage,
        nextSlideMessage: t.nextSlideMessage,
        firstSlideMessage: t.firstSlideMessage,
        lastSlideMessage: t.lastSlideMessage,
        notificationClass: 'swiper-notification'
      }
    });
  });

  document.querySelectorAll('.swiper--colorsTiles').forEach((el) => {
    const swiperColorsTiles = new Swiper(el, {
      modules: [A11y, Pagination, Navigation],
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 36,
      loop: false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      },
      a11y: {
        prevSlideMessage: t.prevSlideMessage,
        nextSlideMessage: t.nextSlideMessage,
        firstSlideMessage: t.firstSlideMessage,
        lastSlideMessage: t.lastSlideMessage,
        notificationClass: 'swiper-notification'
      }
    });
  });

  document.querySelectorAll('.swiper--peoples').forEach((el) => {
    const swiperPeoples = new Swiper(el, {
      modules: [A11y, Pagination, Navigation],
      direction: 'horizontal',
      slidesPerView: 1.15,
      breakpoints: {
        1024: {
          spaceBetween: 120,
          slidesPerView: 1
        }
      },
      slidesPerGroup: 1,
      spaceBetween: 36,
      loop: false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      },
      a11y: {
        prevSlideMessage: t.prevSlideMessage,
        nextSlideMessage: t.nextSlideMessage,
        firstSlideMessage: t.firstSlideMessage,
        lastSlideMessage: t.lastSlideMessage,
        notificationClass: 'swiper-notification'
      }
    });
  });

  document.querySelectorAll('.swiper--people-mobile').forEach((el) => {
    const swiperPeopleMobile = new Swiper(el, {
      modules: [A11y, Pagination, Navigation],
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 32,
      breakpoints: {
        1024: {
          slidesPerView: 4
        }
      },
      loop: false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      },
      a11y: {
        prevSlideMessage: t.prevSlideMessage,
        nextSlideMessage: t.nextSlideMessage,
        firstSlideMessage: t.firstSlideMessage,
        lastSlideMessage: t.lastSlideMessage,
        notificationClass: 'swiper-notification'
      }
    });
  });

  document.querySelectorAll('.swiper--highlights').forEach((el) => {
    const swiperHighlights = new Swiper(el, {
      modules: [A11y, Navigation],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 100,
      loop: false,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      },
      a11y: {
        prevSlideMessage: t.prevSlideMessage,
        nextSlideMessage: t.nextSlideMessage,
        firstSlideMessage: t.firstSlideMessage,
        lastSlideMessage: t.lastSlideMessage,
        notificationClass: 'swiper-notification'
      }
    });
  });

  document.querySelectorAll('.swiper--keyPoints').forEach((el) => {
    const swiperkeyPoints = new Swiper(el, {
      modules: [A11y, Pagination, Navigation],
      direction: 'horizontal',
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 100,
      loop: false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      },
      a11y: {
        prevSlideMessage: t.prevSlideMessage,
        nextSlideMessage: t.nextSlideMessage,
        firstSlideMessage: t.firstSlideMessage,
        lastSlideMessage: t.lastSlideMessage,
        notificationClass: 'swiper-notification'
      }
    });
  });

  document.querySelectorAll('.swiper--history').forEach((el) => {
    const swiperHistory = new Swiper(el, {
      modules: [A11y, Pagination, Navigation],
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev')
      },
      a11y: {
        prevSlideMessage: t.prevSlideMessage,
        nextSlideMessage: t.nextSlideMessage,
        firstSlideMessage: t.firstSlideMessage,
        lastSlideMessage: t.lastSlideMessage,
        notificationClass: 'swiper-notification'
      }
    });
  });
}
